import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { EditNoteDialog } from "../edit-note-dialog";
import { Lead } from "model/lead";
import { styles } from "./style";
import { AppCard } from "component/shared/app-card";

interface Props extends WithStyles<typeof styles> {
	lead: Lead;
}

interface State {
	editNoteDialogIsOpen: boolean;
}

class Component extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			editNoteDialogIsOpen: false,
		};
	}

	public addLineBreak = () => {
		let { note } = this.props.lead;
		const { classes = {} } = this.props;
		if (note) {
			const defaultVal = note.split(/[\r\n]/g).map((text: string, index: number) => {
				if (text.length) {
					return (
						<React.Fragment key={index}>
							{text} <br />
						</React.Fragment>
					)
				} else {
					return (
						<React.Fragment key={index}>
							<br />
						</React.Fragment>
					)
				}
			})
			return <Mui.Typography className={classes.linebreak}>{defaultVal}</Mui.Typography>;
		}
	}

	public render() {
		const { classes = {}, lead } = this.props;
		const { editNoteDialogIsOpen } = this.state;
		return (
			<>
				<EditNoteDialog
					open={editNoteDialogIsOpen}
					onClose={() => this.setState({ editNoteDialogIsOpen: false })}
					lead={lead}
				/>
				<AppCard>
					<Mui.CardHeader
						title="Notes"
						classes={{
							title: classes.title,
							action: classes.action,
						}}
						action={
							<Mui.Button
								onClick={() => this.setState({ editNoteDialogIsOpen: true })}
								variant="text"
								color={"primary"}
							>
								Edit
							</Mui.Button>
						}
					/>
					<Mui.CardContent>
						{lead.note ? (
							this.addLineBreak()
						) : (
							<Mui.Typography color="textSecondary">
								Add lead notes here
							</Mui.Typography>
						)}
					</Mui.CardContent>
				</AppCard>
			</>
		);
	}
}

export const NotesCard = withStyles(Component, styles);
